export const getComponentVariable = (state) => state.localReducer.flag;
export const getComponentData = (state) => state.localReducer.responseData;
